<template>
  <div>
    <!-- 门店执行信息 -->
    <div class="trade-order-block">
      <div v-if="tradeApplyOrderVO.applyType === '04'" class="block-title">PBO计划执行信息</div>
      <div v-else class="block-title">门店执行信息</div>

      <!-- 百威 -->
      <div v-if="tradeApplyOrderVO.applyType === '01'">
        <!-- 高端店招 -->
        <div v-if="tradeApplyExecVO && !tradeApplyExecCooler">
          <div class="block-title block-sub-title">高端店招</div>
          <div class="block-content">
            <el-row class="content-row">
              <el-col :span="3">高端店招主打品牌</el-col>
              <el-col :span="9">{{ tradeApplyExecVO.brandName }}</el-col>
              <el-col :span="3">高端店招主打子品牌</el-col>
              <el-col :span="9">{{ tradeApplyExecVO.subBrandName }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">店招形状</el-col>
              <el-col :span="9">{{ formatShopSignType(tradeApplyExecVO.shopSignType) }}</el-col>
              <el-col :span="3">店招尺寸</el-col>
              <el-col :span="9">高: {{ tradeApplyExecVO.shopSignHeight }}米 长: {{ tradeApplyExecVO.shopSignWidth }}米</el-col>
            </el-row>
            <el-row class="content-row" v-show="tradeApplyExecVO.investAmount">
              <el-col :span="3">预计投入金额</el-col>
              <el-col :span="9">{{ tradeApplyExecVO.investAmount.toFixed(2) | thousandSymbol }}</el-col>
            </el-row>
          </div>
        </div>

        <!-- 物料定制 -->
        <div v-if="tradeApplyExecCustom">
          <div class="block-title block-sub-title">物料定制</div>
          <div class="block-content">
            <el-row class="content-row">
              <el-col :span="3">物料定制主打品牌</el-col>
              <el-col :span="9">{{ tradeApplyExecCustom.brandName }}</el-col>
              <el-col :span="3">物料定制主打子品牌</el-col>
              <el-col :span="9">{{ tradeApplyExecCustom.subBrandName }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">物料定制</el-col>
              <el-col :span="21">{{ formatList(tradeApplyExecCustom.tradeApplyExecCustomList) }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3" v-show="tradeApplyExecCustom.materialDesc">物料定制描述</el-col>
              <el-col :span="9" v-show="tradeApplyExecCustom.materialDesc">{{ tradeApplyExecCustom.materialDesc }}</el-col>
              <el-col :span="3" v-show="tradeApplyExecCustom.investAmount">预计投入金额</el-col>
              <el-col :span="9" v-show="tradeApplyExecCustom.investAmount">{{ tradeApplyExecCustom.investAmount }}</el-col>
            </el-row>
          </div>
        </div>

        <!-- 资产冰柜 -->
        <div v-if="tradeApplyExecCooler">
          <div class="block-title block-sub-title">资产冰柜</div>
          <div class="block-content">
            <div class="content-img cooler-img">
              <div v-for="(item, index) in tradeApplyExecCooler.tradeApplyExecCoolerList" :key="index">
                <el-image :src="setCoolerImage(item)" :preview-src-list="[setCoolerImage(item)]" fit="cover" class="img-wrapper__item" />
                <div class="cooler-name">{{ item.coolerName }}</div>
                <div v-if="item.pledgePayTime" class="cooler-paid-time">付款时间:{{ item.pledgePayTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</div>
              </div>
            </div>
            <el-row class="content-row">
              <el-col :span="3">业务线</el-col>
              <el-col :span="9">{{ tradeApplyInfoVO.clientTypeName }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">押金支付人姓名</el-col>
              <el-col :span="9">{{ tradeApplyExecVO.paidContactPerson }}</el-col>
              <el-col :span="3">押金支付人电话</el-col>
              <el-col :span="9">{{ tradeApplyExecVO.paidContactPhone }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">收货人姓名</el-col>
              <el-col :span="9">{{ tradeApplyBaseVO.keyContactPerson }}</el-col>
              <el-col :span="3">收货人电话</el-col>
              <el-col :span="9">{{ tradeApplyBaseVO.keyContactPhone }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">业务员姓名</el-col>
              <el-col :span="9">{{ tradeApplyInfoVO.salesContactPerson }}</el-col>
              <el-col :span="3">业务员电话</el-col>
              <el-col :span="9">{{ tradeApplyInfoVO.salesContactPhone }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">提报说明</el-col>
              <el-col :span="21">{{ tradeApplyInfoVO.applyDesc }}</el-col>
            </el-row>
          </div>
        </div>

        <!-- 完美门店 -->
        <div v-if="tradeApplyExecStack">
          <div class="block-title block-sub-title">完美门店</div>
          <div class="block-content">
            <el-row class="content-row">
              <el-col :span="3">售点类型</el-col>
              <el-col :span="9">{{ tradeApplyExecStackDTO.stackSpecs === '01' ? '尊享售点' : '品质售点' }}</el-col>
              <el-col :span="3">堆箱执行类别</el-col>
              <el-col :span="9">{{ tradeApplyExecStackDTO.stackExecTypeName }}</el-col>
            </el-row>
            <el-row class="content-row" v-if="tradeApplyExecStackDTO.stackMenuDesc">
              <el-col :span="3">套餐内容</el-col>
              <el-col :span="21">{{ tradeApplyExecStackDTO.stackMenuDesc }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">堆箱活动名称</el-col>
              <el-col :span="9">{{ tradeApplyExecStackDTO.stackEventName }}</el-col>
              <el-col :span="3">堆箱品牌</el-col>
              <el-col :span="9">{{ tradeApplyExecStack.brandDesc }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3" v-if="tradeApplyExecStackDTO.displayFeeType">陈列费用</el-col>
              <el-col :span="9" v-if="tradeApplyExecStackDTO.displayFeeType">{{ tradeApplyExecStackDTO.displayFeeType }}</el-col>
              <el-col :span="3" v-if="tradeApplyExecStackDTO.bonusFee">每周激励金额</el-col>
              <el-col :span="9" v-if="tradeApplyExecStackDTO.bonusFee">{{ tradeApplyExecStackDTO.bonusFee }}</el-col>
              <el-col :span="3">堆箱子品牌</el-col>
              <el-col :span="9">{{ tradeApplyExecStack.subBrandDesc }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3" v-if="tradeApplyExecStackDTO.execWeeks">堆箱执行周数</el-col>
              <el-col :span="9" v-if="tradeApplyExecStackDTO.execWeeks">{{ tradeApplyExecStackDTO.execWeeks }}</el-col>
              <el-col :span="3" v-if="tradeApplyExecStackDTO.stackVersion">堆箱版本</el-col>
              <el-col :span="9" v-if="tradeApplyExecStackDTO.stackVersion">{{ tradeApplyExecStackDTO.stackVersion }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3" v-if="tradeApplyExecStackDTO.stackSize">堆箱规格</el-col>
              <el-col :span="9" v-if="tradeApplyExecStackDTO.stackSize">{{ tradeApplyExecStackDTO.stackSize }}</el-col>
              <el-col :span="3" v-if="tradeApplyExecStackDTO.mixinPackName">混堆名称</el-col>
              <el-col :span="9" v-if="tradeApplyExecStackDTO.mixinPackName">{{ tradeApplyExecStackDTO.mixinPackName }}</el-col>
            </el-row>
            <el-row class="content-row" v-if="tradeApplyExecStackDTO.stackSize">
              <el-col :span="24">混堆设计图</el-col>
              <el-col :span="24" class="stack-wrapper">
                <div class="stack-column" v-for="(cItem, cIndex) in Number(tradeApplyExecStackDTO.stackSize.split('*')[0])" :key="cIndex">
                  <div class="stack-row" :style="{backgroundColor: getBrandInfo('color', rIndex)}" v-for="(item, rIndex) in Number(tradeApplyExecStackDTO.stackSize.split('*')[1])" :key="rIndex">
                    <span :title="getBrandInfo('name', rIndex)">{{ getBrandInfo('name', rIndex) }}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row class="content-row" v-if="tradeApplyExecStackDTO.displayFeeDetail">
              <el-col :span="3">售点投入规则</el-col>
              <el-col :span="9">
                <div class="content-display">
                  <div v-for="(item, index) in tradeApplyExecStackDTO.displayFeeDetail" :key="index">
                    <div>{{ getWeekName(index) }}</div>
                    <div class="content-display-num">{{ item }}元</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- ISP -->
      <div v-if="tradeApplyOrderVO.applyType === '03'">
        <div class="block-title block-sub-title">{{ setIspOrderType(tradeApplyExecVO.execTypeSub) }}</div>
        <div class="block-content">
          <el-row class="content-row">
            <el-col :span="3">主品牌</el-col>
            <el-col :span="9">{{ tradeApplyExecVO.brandName }}</el-col>
            <el-col :span="3">子品牌</el-col>
            <el-col :span="9">{{ tradeApplyExecVO.subBrandName }}</el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">预计投入金额</el-col>
            <el-col :span="9">{{ tradeApplyExecVO.investAmount }}元</el-col>
            <el-col :span="3">门店位置</el-col>
            <el-col :span="9">{{ ispOrderData.pocLocalName }}</el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">有无户外就餐/饮酒区</el-col>
            <el-col :span="9">
              <span v-if="ispOrderData.drinkArea === '01'">有</span>
              <span v-if="ispOrderData.drinkArea === '02'">无</span>
            </el-col>
            <el-col :span="3">周末满座率</el-col>
            <el-col :span="9">
              <span v-if="ispOrderData.weekendFullSeat === '01'">70%及以上</span>
              <span v-if="ispOrderData.weekendFullSeat === '02'">70%以下</span>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">大众点评评分</el-col>
            <el-col :span="9">{{ setScore(ispOrderData.dianpinScore) }}</el-col>
            <el-col :span="3">陈列保留时间</el-col>
            <el-col :span="9">{{ ispOrderData.displayTimeName }}</el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">定制位置</el-col>
            <el-col :span="9">{{ setLocation(ispOrderData.customLocationNameList) }}</el-col>
            <el-col :span="3">定制位置补充说明</el-col>
            <el-col :span="9" style="word-break: break-all">{{ ispOrderData.customLocationDesc }}</el-col>
          </el-row>
        </div>
      </div>

      <!-- pbo -->
      <div v-if="tradeApplyOrderVO.applyType === '04'">
        <div class="block-content">
          <el-row type="flex" justify="center">
            <el-col>
              <PointerStep ref="PointerStep" :tradeApplyExecPboDTO="tradeApplyExecPboDTO"/>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-table class="order-data-table ie-table" :data="tradeApplyExecPboDTO.tradePboPointSkuList">
              <el-table-column label="sku" prop="skuName" />
              <el-table-column label="预估年销量" prop="qty" />
            </el-table>
            <!-- <el-col :span="3">sku</el-col>
            <el-col :span="9">{{ item.skuName }}</el-col>
            <el-col :span="3">预估年销量</el-col>
            <el-col :span="9">{{ item.qty }}</el-col> -->
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">是否ABI专卖</el-col>
            <el-col :span="9">
              <span v-if="tradeApplyExecPboDTO.flagAbiStore === 1">是</span>
              <span v-if="tradeApplyExecPboDTO.flagAbiStore === 0">否</span>
            </el-col>
            <el-col :span="3">是否有POS机</el-col>
            <el-col :span="9">
              <span v-if="tradeApplyExecPboDTO.flagHasPos === 1">是</span>
              <span v-if="tradeApplyExecPboDTO.flagHasPos === 0">否</span>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">是否有一次性餐具</el-col>
            <el-col :span="9">
              <span v-if="tradeApplyExecPboDTO.flagHasDisposable === 1">是</span>
              <span v-if="tradeApplyExecPboDTO.flagHasDisposable === 0">否</span>
            </el-col>
            <el-col :span="3">年销量标箱数</el-col>
            <el-col :span="9">{{ tradeApplyExecPboDTO.totalSalePoint }}箱</el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">标准单箱投入</el-col>
            <el-col :span="9">{{ tradeApplyExecPboDTO.singlePointInvest }}元</el-col>
            <!-- <el-col :span="3">ROI</el-col>
            <el-col :span="9">{{ tradeApplyExecPboDTO.roiValue }}元</el-col> -->
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">开始时间</el-col>
            <el-col :span="9">{{ tradeApplyExecPboDTO.startDate | parseTime('{y}-{m}-{d}') }}</el-col>
            <el-col :span="3">预计结束时间</el-col>
            <el-col :span="9">{{ tradeApplyExecPboDTO.endDate | parseTime('{y}-{m}-{d}') }}</el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">阶段数</el-col>
            <el-col :span="9">{{ tradeApplyExecPboDTO.stageNumber }}</el-col>
            <el-col :span="3">激励方式</el-col>
            <el-col :span="9">
              <span v-if="tradeApplyExecPboDTO.bonusType === '01'">现金</span>
              <span v-if="tradeApplyExecPboDTO.bonusType === '02'">免费酒</span>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3" v-if="tradeApplyExecPboDTO.bonusType === '02'">赠酒sku</el-col>
            <el-col :span="9" v-if="tradeApplyExecPboDTO.bonusType === '02'">{{ tradeApplyExecPboDTO.bonusBeerSkuName }}</el-col>
            <el-col :span="3">
              <span v-if="tradeApplyExecPboDTO.bonusType === '01'">总激励金额</span>
              <span v-if="tradeApplyExecPboDTO.bonusType === '02'">总赠酒数量</span>
            </el-col>
            <el-col :span="9">
              <span v-if="tradeApplyExecPboDTO.bonusType === '01'">{{ tradeApplyExecPboDTO.bonusFeeTotal }}元</span>
              <span v-if="tradeApplyExecPboDTO.bonusType === '02'">{{ tradeApplyExecPboDTO.bonusBeerTotal }}箱</span>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="3">提报说明</el-col>
            <el-col :span="21" v-if="applyDesc">{{ applyDesc }}</el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { mapGetters } from 'vuex'
import PointerStep from './pointer-step'

export default {
  name: 'store-exec-info',
  components: {
    PointerStep
  },
  data () {
    return {
      tradeApplyOrderVO: '',
      tradeApplyExecVO: '',
      tradeApplyExecCooler: '',
      tradeApplyExecCustom: '',
      tradeApplyExecStack: '',
      ispOrderData: '',
      tradeApplyExecPboDTO: '',
      applyDesc: '',
      tradeApplyExecStackDTO: '',
      isMyApprove: false,
      brandInfoMap: {},
      tradeApplyBaseVO: {},
      tradeApplyInfoVO: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    codeImg () {
      const type = process.env.NODE_ENV === 'development' ? 'dev' : 'prod'
      return `https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/abipocm/h5/cooler/deposit_code_${type}.png`
    }
  },
  methods: {
    setExecInfo (info) {
      this.tradeApplyOrderVO = info
      this.tradeApplyExecVO = info.tradeApplyExecVO
      this.tradeApplyExecCooler = info.tradeApplyExecCooler
      this.tradeApplyExecCustom = info.tradeApplyExecCustom
      this.tradeApplyExecStack = info.tradeApplyExecStack
      this.ispOrderData = info.ispOrderData
      this.tradeApplyExecPboDTO = info.tradeApplyExecPboDTO
      this.tradeApplyBaseVO = info.tradeApplyBaseVO
      this.tradeApplyInfoVO = info.tradeApplyInfoVO
      this.applyDesc = this.tradeApplyInfoVO.applyDesc
      if (this.userInfo.clientId === this.tradeApplyInfoVO.approvalClientId) {
        this.isMyApprove = true
      }

      if (this.tradeApplyExecStack) {
        this.tradeApplyExecStackDTO = this.tradeApplyExecStack.tradeApplyExecStackDTO
        if (this.tradeApplyExecStackDTO.mixinPackOrderList) {
          this.tradeApplyExecStackDTO.mixinPackOrderList.forEach(item => {
            this.brandInfoMap[item.abiBrandCode] = {
              color: item.tradeStackColor,
              name: item.abiBrandDesc
            }
          })
        }
      }
    },

    // 店招形状
    formatShopSignType (val) {
      if (val === '01') return '一字型'
      if (val === '02') return 'L型'
      if (val === '03') return 'U型'
      return ''
    },

    // 物料定制
    formatList (arr) {
      let customList = []
      if (arr.length) {
        arr.forEach(item => {
          customList.push(item.positionName)
        })
      }
      return customList.join('，')
    },

    // 冰柜照片
    setCoolerImage (item) {
      let uri = ''
      if (item.itemImageList) {
        uri = item.itemImageList[0].imageFileUri
      }
      if (item.freezerUri) {
        uri = item.freezerUri[0]
      }
      return this.getImg(uri)
    },

    // 售点投入金额
    getWeekName (index) {
      let weekList = ['第一周', '第二周', '第三周', '第四周', '第五周', '额外激励']
      return weekList[index]
    },

    // isp订单类型
    setIspOrderType (val) {
      if (val === '301') return 'ISP高端执行'
      if (val === '302') return 'ISP形象店'
      if (val === '303') return 'ISP物料定制'
      return ''
    },

    // 大众点评评分
    setScore (val) {
      if (val === '01') return '四分及以上'
      if (val === '02') return '三分'
      if (val === '03') return '两分以下'
    },

    // 定制位置
    setLocation (arr) {
      if (!arr) {
        return
      }
      return arr.join('，')
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    },

    getBrandInfo (type, index) {
      if (this.tradeApplyExecStackDTO.mixinPackOrderList && this.tradeApplyExecStackDTO.mixinPackOrderList.length) {
        const mixinPackOrder = this.tradeApplyExecStackDTO.mixinPackOrder.split(',')
        if (mixinPackOrder[index]) {
          const key = mixinPackOrder[index]
          return this.brandInfoMap[key][type]
        }
      } else {
        return type === 'color' ? this.tradeApplyExecStack.tradeStackColor : this.tradeApplyExecStack.subBrandDesc
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cooler-img {
  display: flex;
  align-items: center;

  &>div {
    width: 120px;
    height: 120px;
    margin: $content-middle 0 0px 20px;
    text-align: center;
    padding-bottom: 55px;

    img {
      max-width: 100%;
      max-height: 100%;
      cursor: pointer;
    }

    .cooler-name {
      margin-top: 5px;
    }

    .btn-red {
      margin: 5px;
    }
  }

  .block-content-quota {
    font-size: 12px;
    margin-top: 5px;
    color: #666;
  }
}

.content-display {
  display: flex;
  align-items: center;

  &>div {
    text-align: center;
    margin-right: $content-middle;
  }

  .content-display-num {
    margin-top: 5px;
  }
}
.stack-wrapper {
  text-align: center;
  line-height: 0;
  .stack-row {
    display: inline-block;
    overflow: hidden;
    width: 60px;
    height: 60px;
    line-height: 1.2;
    font-size: 12px;
    border: 1px solid rgb(192, 196, 204);
    color: #fff;
    span {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
    }
  }
}
.block-sub-title {
  position: relative;
  .btn-red {
    position: absolute;
    right: 0;
    top: -8px;
  }
}
.deposit-code {
  width: 200px;
  height: 200px;
  margin: auto;
  img {
    width: 100%;
    height: 100%;
  }
}
.cooler-paid-time {
  margin-top: 5px;
  color: #999;
  font-size: 12px;
}
</style>
